// La cámara de la oficina: si el mundo es más grande que la ventana, arranca centrada en la primera mesa que te
// necesita (si hay) o, si no, arriba (la oficina se apoya arriba, como los iconos; crítica N1). Solo se mueve cuando cambia la GEOMETRÍA del mundo (zoom,
// tamaño, panel), nunca porque llegue un aviso: no mueve la oficina bajo el ratón de Pau.
import { useLayoutEffect, type RefObject } from 'react';
import type { MesaMundo, Mundo } from './generar';

export function useCamara(caja: RefObject<HTMLDivElement>, mundo: Mundo | null, panelIzqPx: number, objetivo: MesaMundo | undefined): void {
  useLayoutEffect(() => {
    const el = caja.current;
    if (!el || !mundo) return;
    const e = mundo.encuadre;
    el.scrollLeft = Math.max(0, (e.x + e.w / 2) * mundo.z - (panelIzqPx + (el.clientWidth - panelIzqPx) / 2));
    el.scrollTop = objetivo ? Math.max(0, (objetivo.rect.y + objetivo.rect.h / 2) * mundo.z - el.clientHeight / 2) : 0;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mundo?.z, mundo?.ancho, mundo?.alto, panelIzqPx]);
}
